import { memo } from 'react';

import { FooterNavigation } from './FooterNavigation/FooterNavigation';

const FooterNav = memo(() => {
  return <FooterNavigation />;
});

FooterNav.displayName = 'FooterNav';

export default FooterNav;
